/**
 * Coordinator API functions
 */

import { apiClient } from '../api-client';

// ============= Type Definitions =============

export interface HospitalRegistration {
  name: string;
  address: string;
  city: string;
  state: string;
  pincode: string;
  phone: string;
  email?: string;
  contact_person?: string;
  hospital_type?: 'government' | 'private' | 'trust';
}

export const coordinatorsApi = {
  /**
   * Get list of all coordinators
   */
  getCoordinators: async (): Promise<any> => {
    return apiClient.get('/coordinators');
  },

  /**
   * Get coordinator by ID
   */
  getCoordinator: async (coordinatorId: number): Promise<any> => {
    return apiClient.get(`/coordinators/${coordinatorId}`);
  },

  /**
   * Get coordinator dashboard summary (current logged-in coordinator)
   */
  getCoordinatorDashboardSummary: async (): Promise<any> => {
    return apiClient.get('/coordinators/me/summary');
  },

  /**
   * Register a new hospital in the system
   * Used by: CoordinatorDashboard component (hospital management)
   */
  registerHospital: async (data: HospitalRegistration): Promise<{
    status: string;
    message: string;
    hospital_id: number;
    hospital_name: string;
  }> => {
    return apiClient.post('/coordinators/hospitals', data);
  },
};